exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 3rem;\n  padding-top: 8rem;\n  padding-bottom: 2rem; }\n  .app-footer a {\n    text-decoration: none;\n    color: rgba(17, 17, 17, 0.82); }\n  .claim-your-profile .app-footer {\n    display: none; }\n  .app-footer ul {\n    margin: 0;\n    padding: 0; }\n    .app-footer ul li {\n      list-style: none;\n      display: inline-block;\n      margin-right: 1rem; }\n      .app-footer ul li:last-of-type {\n        margin-right: 0; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/shared/footer/footer.scss
// module id = 585
// module chunks = 0